import { SearchFormType } from "../../search-page/search-page-type.enum";
import { SeStepperSideNavComponentType } from "../se-stepper-side-nav.models";

// sidenav dettagli recap
export interface ISeStepperSideNavChildrenState { 
    patientId: string; // paziente selezionato
    examId: string; // Esame selezionato
    message: string; // Messaggio visualizzato quando non ci sono items
}

export const seStepperSideNavChildrenInitialState : ISeStepperSideNavChildrenState = {
    patientId: null,
    examId: null,
    message: null
};




// sidenav padre per gestione tabs
export interface ISeStepperSideNavParentFeatureState {
    title : string; // titolo del tab
    description : string; // descrizione sezione
    icon : string | null; // icona tab
    active : boolean; // attivo/disattivo
}

export interface ISeStepperSideNavParentState extends ISeStepperSideNavParentFeatureState {
    searchForm : SearchFormType | null;
    idColumnName : string;
}

export type SeStepperSideNavParentState = {
    [SeStepperSideNavComponentType.summary] : ISeStepperSideNavParentState,
    [SeStepperSideNavComponentType.documents] : ISeStepperSideNavParentFeatureState,
};

export const seStepperSideNavParentInitialState : SeStepperSideNavParentState = {
    [SeStepperSideNavComponentType.summary]: {
        title: 'Summary',
        description: '',
        icon: 'list_alt',
        active: false,
        searchForm: null,
        idColumnName: ''
    },
    [SeStepperSideNavComponentType.documents]: {
        title: 'Documents',
        description: '',
        icon: 'photo_album',
        active: false,
    }
};


